import React from 'react';

import { ExpandCircleDown, Info } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';

import { useAppDispatch, useAppSelector } from 'state/hooks';
import { selectMaximize, setMaximize } from 'state/workflowSlice';

import { MAXIMIZE_DATA } from 'appConstants';

// https://mui.com/material-ui/material-icons/

// import styles from 'features/chart/Chart.module.css';

export function MaximizeButton() {
  const maximize = useAppSelector(selectMaximize);
  const dispatch = useAppDispatch();

  const rotate = maximize === MAXIMIZE_DATA ? 'rotate(0)' : 'rotate(180deg)';
  // console.log(`maximize: ${maximize} rotate: ${rotate}`);
  const handleMaximizeChartButtonClick = () =>
    dispatch(setMaximize(maximize ? null : MAXIMIZE_DATA));

  return (
    <IconButton
      color="primary"
      aria-label="expand chart"
      onClick={handleMaximizeChartButtonClick}
    >
      <ExpandCircleDown
        style={{ transform: rotate, transition: 'all 0.2s linear' }}
      />
    </IconButton>
  );
}

const buttonSx = {
  position: 'absolute',
  bottom: 0,
  right: 0,
  zIndex: 1,
};

export function MaximizeOnlyButton() {
  const dispatch = useAppDispatch();
  const maximize = useAppSelector(selectMaximize);
  const handleClick = () => dispatch(setMaximize(null));
  if (!maximize) return null;
  return (
    <IconButton
      sx={buttonSx}
      color="primary"
      aria-label="expand chart"
      onClick={handleClick}
    >
      <Info />
    </IconButton>
  );
}
